@if (!showCreatorDialog) {
  <div>
    <div class="draw-toolbar">
      <div class="toolbar-content">
        <div class="toolbar-switch">
          @switch (selection) {
            @case ('drawshape') {
              <div class="d-flex align-items-center">
                <span class="instruction-text">
                  Click any where on the globe to add point to create an incident.
                  Double&nbsp;tab a point or click the
                  <span class="done-text">Done</span>
                  button to finish drawing.
                </span>
                <div class="toolbar-actions">
                  <button class="btn btn-done" (click)="finishedDrawClicked()">
                    Done <i class="fa fa-check"></i>
                  </button>
                  <button class="btn btn-cancel" (click)="cancelDrawClicked()">
                    Cancel <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            }
            @case ('focalpoint') {
              <div class="d-flex align-items-center">
                <div [innerHTML]="focalPointDivMessage" class="instruction-text"></div>
                <div class="toolbar-actions">
                  <button class="btn btn-primary" (click)="setFocalPointButtonClicked()">
                    <i class="fa-solid fa-map-pin"></i>
                    {{focalPointText}}
                  </button>
                  <button class="btn btn-danger" (click)="continueButtonClicked()">
                    <i class="fa-solid fa-arrow-right"></i>
                    Continue
                  </button>
                </div>
              </div>
            }
            @case ('addpoint') {
              <div>
                <div class="d-flex align-items-center">
                  <div class="instruction-text">Click anywhere on the globe to set the focal point.</div>
                  <div class="toolbar-actions">
                    <button class="btn btn-cancel" (click)="cancelFocalPointClicked()">
                      <i class="fa fa-times"></i>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
      <button class="btn btn-light close-btn" (click)="onCloseClick()">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
}

<div class="modal fade" tabindex="-1" [ngClass]="{'show d-block': showCreatorDialog}" [style.display]="showCreatorDialog ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-body modal-content">
      @if (showCreatorDialog) {
        <div>
          <app-creator-dialog
            [dialogData]="creatorDialogData"
            (close)="creatorDialogClosed($event)">
          </app-creator-dialog>
        </div>
      }
    </div>
  </div>